export enum LoadStatus {
  notRequested = 1,
  notLoading = 2,
  loading = 3,
  loaded = 4,
}
